/**
 * Tooltip now lives in the shared design system, @atomic/ui-kit — shared with
 * chomps. Thin re-export shim; existing imports keep working unchanged.
 */
export { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@atomic/ui-kit"
